import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Duplicate = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M23.093,22.943h-16v-16h16V22.943z M9.093,20.943h12v-12h-12V20.943z" }),
    React.createElement("polygon", { points: "19.093,13.943 16.093,13.943 16.093,10.943 14.093,10.943 14.093,13.943 11.093,13.943 11.093,15.943 14.093,15.943 14.093,18.943 16.093,18.943 16.093,15.943 19.093,15.943 " }),
    React.createElement("polygon", { points: "5.339,15.284 0.907,15.284 0.907,1.057 15.323,1.057 15.323,5.308 13.323,5.308 13.323,3.057 2.907,3.057 2.907,13.284 5.339,13.284 \t" })), 'Duplicate');
export default Duplicate;
